<div [formGroup]="detailsForm" class="map-details no-field-space">

  <!-- Loading spinner to prevent user from doing anything during validation. -->
  <div class="loading-spinner" *ngIf="requestRunning">
    <i class="spinner fa-light fa-spinner fa-spin"></i>
  </div>

  <div class="map-upload-button-area">

    <label for="map-upload-button" title="Upload map file">
      <div class="button-content">
        <i class="far fa-map button-icon"></i>
        <div class="button-label">Kartendatei hochladen</div>
      </div>
    </label>
    <input id="map-upload-button" name="map-btn" class="map-upload-button" type="file" accept="image/*"
      (change)="handleMapChangeEvent($event)" />

  </div>

  <div class="dimensions">
    <mat-form-field class="input" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.width"></sc-dictionary-label>
      </mat-label>
      <input matInput matInputInteger name="width" formControlName="width"
        [required]="true" type="NUMBER">
    </mat-form-field>

    <div class="spacer"></div>

    <mat-form-field class="input" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.height"></sc-dictionary-label>
      </mat-label>
      <input matInput matInputInteger name="height" formControlName="height"
        [required]="true" type="NUMBER">
    </mat-form-field>
  </div>

  <div class="legend-orientation">
    <mat-form-field class="input" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.legend-position"></sc-dictionary-label>
      </mat-label>
      <mat-select
        name="legendPosition" formControlName="legendPosition">
        <mat-option [value]="position" *ngFor="let position of legendPositionOptions">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.yard-map-configuration.legend-position.{{position}}"></sc-dictionary-label>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>
